import * as QuoteActions from './../actions/marine-quote.actions';
import { MarineQuoteData } from '../models/marinequote.model';
import { AppState } from '../state/App.state';

const initialState: MarineQuoteData = {
    inputRequest: {
    },
    quotationId: '',
    referralReasons: [],
    status: '',
    brmsResponse: ''
};

export function marinequoteDataReducer(state: MarineQuoteData = initialState, action: QuoteActions.Actions): MarineQuoteData {

    switch (action.type) {
        case QuoteActions.UPDATE_MARINE_QUOTE_DATA:
            return Object.assign({}, state, action.payload);
        default:
            return state;
    }
}

export const selectQuoteData = (state: AppState) => state.quoteData;
